/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {
    Coordinate2d,
    Positionable,
    SimpleReelModelDelegate,
    SimpleReelModelState,
    SimpleReelModelSymbolData,
    SimpleReelModelSymbolPosition
} from "../../core/reel/simplereel/SimpleReelModel";
import {TheCage} from "../TheCage";
import {TheCageStatics} from "../config/TheCageStatics";
import {TheCageSymbol, TheCageSymbolStates} from "./TheCageSymbol";
import {MathUtils} from "../utils/MathUtils";
import {TheCageGameAssets} from "../TheCageGameAssets";
import {SimpleMatrixAvalancheModel} from "../../core/reel/simplereel/SimpleMatrixAvalancheModel";
import {MultiplierDisplay} from "../view/MultiplierDisplay";
import {WinWaysDisplay} from "../view/WinWaysDisplay";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {LayersSet} from "./LayersSet";
import {gsap} from "gsap";
import {ScatterSymbol} from "./ScatterSymbol";
import {XBombSymbol} from "./XBombSymbol";
import {TheCageSound} from "../sound/TheCageSound";
import {GuiToggleButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiToggleButton";
import {ToggleState} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/ToggleState";
import {BasicToggleButton} from "../components/BasicToggleButton";
import {BetBoostData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetHandler";


export class TheCageReelsView extends PIXI.Container implements StageLayer, SimpleReelModelDelegate {
    private _anticipationAnimation:PIXI.spine.Spine[];
    public avalancheMatrixModel:SimpleMatrixAvalancheModel;

    private betBoostAllowed:boolean = false;
    private betBoostPaused:boolean = false;


    private static DEFAULT_REEL_SET:string[][] = [
        ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "W", "W2"],
        ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "W", "W2"],
        ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "W", "W2"],
        ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "W", "W2"],
        ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "W", "W2"],
        ["L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4", "W", "W2"],
    ];

    private _guiContainer:PIXI.Container;

    public multiplierDisplay:MultiplierDisplay;

    public layers:LayersSet;
    public startPositions:Coordinate2d[][];
    private _frameBackground:PIXI.Sprite;
    private _blackout:PIXI.Sprite;
    private _blackoutAnimation:gsap.core.Animation | undefined;
    private _overlayGui:PIXI.Container;

    constructor() {
        super();
        this.name = "TheCageReelsView";
        this.init();
    }

    private init() {
        this.layers = new LayersSet();

        this._blackout = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._blackout.tint = 0;
        this._blackout.position.set(360,360);
        this._blackout.anchor.set(0.5,0.5);
        this._blackout.alpha = 0;

        this._anticipationAnimation = [];
        for (let i = 0; i < 6; i++) {
            this._anticipationAnimation.push(new PIXI.spine.Spine(TheCage.assetLoader.getSpineAsset(TheCageGameAssets.SCATTER_ATTENTION)));
            this._anticipationAnimation[i].visible = false;
        }
        this._anticipationAnimation[0].position.set(194, 110);
        this._anticipationAnimation[1].position.set(358, 110);
        this._anticipationAnimation[2].position.set(522, 110);
        this._anticipationAnimation[3].position.set(606, 192);
        this._anticipationAnimation[4].position.set(606, 356);
        this._anticipationAnimation[5].position.set(606, 520);

        const columns = 7;
        this.avalancheMatrixModel = new SimpleMatrixAvalancheModel(7, this, true);

        this.startPositions = [];
        for (let i:number = 0; i < 7; i++) {
            if (i % 2 == 0) {
                this.startPositions.push([
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET + TheCageStatics.REEL_AREA_X_OFFSET,
                        y:TheCageStatics.REEL_Y_OFFSET * 0.5 + TheCageStatics.REEL_AREA_Y_OFFSET
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET + TheCageStatics.REEL_AREA_X_OFFSET,
                        y:TheCageStatics.REEL_Y_OFFSET * 1.5 + TheCageStatics.REEL_AREA_Y_OFFSET
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET + TheCageStatics.REEL_AREA_X_OFFSET,
                        y:TheCageStatics.REEL_Y_OFFSET * 2.5 + TheCageStatics.REEL_AREA_Y_OFFSET
                    },
                ]);
            } else {
                this.startPositions.push([
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET + TheCageStatics.REEL_AREA_X_OFFSET,
                        y:TheCageStatics.REEL_Y_OFFSET * 0 + +TheCageStatics.REEL_AREA_Y_OFFSET
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET + TheCageStatics.REEL_AREA_X_OFFSET,
                        y:TheCageStatics.REEL_Y_OFFSET * 1 + +TheCageStatics.REEL_AREA_Y_OFFSET
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET + TheCageStatics.REEL_AREA_X_OFFSET,
                        y:TheCageStatics.REEL_Y_OFFSET * 2 + +TheCageStatics.REEL_AREA_Y_OFFSET
                    },
                    {
                        x:i * TheCageStatics.REEL_X_OFFSET + TheCageStatics.REEL_AREA_X_OFFSET,
                        y:TheCageStatics.REEL_Y_OFFSET * 3 + +TheCageStatics.REEL_AREA_Y_OFFSET
                    },
                ]);
            }
        }


        this.multiplierDisplay = new MultiplierDisplay();


        this._guiContainer = new PIXI.Container();
        this._guiContainer.name = "_guiContainer";
        this._guiContainer.addChild(this.multiplierDisplay);

        this.betBoostAllowed = TheCage.apiPlugin.gameClientConfiguration.boostedBetAllowed;
        //if(this.betBoostAllowed) {
        //    this.addXBetButton();
        //}

        this._overlayGui = new PIXI.Container();
        this._overlayGui.name = "_overlayGui";

        const mask = this.createMask();
        this.layers.maskedNormal.addChild(mask);
        this.layers.maskedNormal.mask = mask;

        //this._anticipationAnimation.mask = mask;

        this.addChild(this._blackout);
        this._anticipationAnimation.forEach((anim) => this.addChild(anim));

        this.addChild(this.layers.maskedNormal);
        this.addChild(this.layers.maskedOver);
        this.addChild(this.layers.maskedHighlight);
        this.addChild(this.layers.win);
        this.addChild(this.layers.winOver);
        this.addChild(this._guiContainer);
        this.addChild(this.layers.overlay);
        this.addChild(this._overlayGui);

        this.onResize();

    }

    private createMask():PIXI.Graphics {
        const normalPolygon:PIXI.Point[] = [
            new PIXI.Point(0, 2),
            new PIXI.Point(2, 0),
            new PIXI.Point(3, 1),
            new PIXI.Point(4, 0),
            new PIXI.Point(5, 1),
            new PIXI.Point(6, 0),
            new PIXI.Point(8, 2),

            new PIXI.Point(7, 3),
            new PIXI.Point(8, 4),
            new PIXI.Point(7, 5),
            new PIXI.Point(8, 6),
            new PIXI.Point(6, 8),


            new PIXI.Point(5, 7),
            new PIXI.Point(4, 8),
            new PIXI.Point(3, 7),
            new PIXI.Point(2, 8),
            new PIXI.Point(1, 7),

            new PIXI.Point(0, 6),

            new PIXI.Point(1, 5),
            new PIXI.Point(0, 4),
            new PIXI.Point(1, 3),
        ];

        for (let i:number = 0; i < normalPolygon.length; i++) {
            normalPolygon[i] = MathUtils.multiplyPoints(normalPolygon[i], new PIXI.Point(TheCageStatics.STEP_WIDTH, TheCageStatics.STEP_HEIGHT));
            normalPolygon[i].x += TheCageStatics.REEL_AREA_X_OFFSET;
            normalPolygon[i].y += TheCageStatics.REEL_AREA_Y_OFFSET;

            normalPolygon[i].x -= TheCageStatics.STEP_WIDTH;
            normalPolygon[i].y -= TheCageStatics.STEP_HEIGHT;
        }

        const mask = new PIXI.Graphics();
        mask.beginFill(0xffffff, 0.3);
        mask.drawPolygon(normalPolygon);
        mask.endFill();

        return mask;
    }

    onResize():void {
        this._blackout.width = NolimitApplication.screenBounds.width;
        this._blackout.height = NolimitApplication.screenBounds.height;

        if (NolimitApplication.isLandscape) {
            this.multiplierDisplay.position.set(750, 135);
        } else {
            this.multiplierDisplay.position.set(635, 20);
        }

    }

    createSymbol(symbolName:string, state:SimpleReelModelState, symbolPosition:SimpleReelModelSymbolPosition):Positionable {
        const symbolState:TheCageSymbolStates = state == SimpleReelModelState.SPIN ? TheCageSymbolStates.SPIN : TheCageSymbolStates.NORMAL;

        let symbol:TheCageSymbol;
        if (TheCageStatics.isScatterSymbol(symbolName)) {
            symbol = new ScatterSymbol(symbolName, symbolState, this);
        }
        else if (symbolName == "WB") {
            symbol = new XBombSymbol(symbolName, symbolState, this);
        }
        else {
            symbol = new TheCageSymbol(symbolName, symbolState, this);
        }


        if(symbolName == "BLANK"){
            symbol.getStateAnimation(TheCageSymbolStates.REMOVE);
        }


        if (state == SimpleReelModelState.FILL_UP) {
            this.layers.maskedNormal.addChildAt(symbol, 0);
        } else {
            this.layers.maskedNormal.addChild(symbol);
        }
        return symbol;
    }

    removeSymbol(symbolData:SimpleReelModelSymbolData):void {
        (<TheCageSymbol>symbolData.positionable).destroy();
    }

    getVisibleSymbolDataAt(column:number, row:number):SimpleReelModelSymbolData {
        const visibleSymbols = this.avalancheMatrixModel.getAllVisibleSymbols();
        return visibleSymbols[column][row];
    }

    public transformSymbolAt(column:number, row:number, toSymbol:string):{oldSymbol:SimpleReelModelSymbolData, newSymbol:SimpleReelModelSymbolData} {
        const data = this.avalancheMatrixModel.swapSymbol(toSymbol, column, row);
        this.layers.maskedNormal.addChildAt(<TheCageSymbol>data.newSymbol.positionable, this.layers.maskedNormal.getChildIndex(<TheCageSymbol>data.oldSymbol.positionable));
        return data;
    }

    hide(duration:number = 0.1) {
        const tl = gsap.timeline();

        tl.add(gsap.to(this, {duration:duration, alpha:0, ease:"none"}));
        tl.add(() => {
            this.visible = false;
        });
        return tl;
    }

    show(duration:number = 0.1):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.visible = true;
        });
        tl.add(gsap.to(this, {duration:duration, alpha:1, ease:"none"}));
        return tl;
    }

    public scatterAttention(newSymbols:SimpleReelModelSymbolData[][], landedFinalScatter:boolean): gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(() => {
            if (this._blackoutAnimation){
                this._blackoutAnimation.kill();
            }
            this._blackoutAnimation = gsap.to(this._blackout, {duration:2, alpha: 0.7});
            //his.waterSpine
            TheCage.soundPlayer.playSound(TheCageSound.ANTICIPATION_START);
            TheCage.soundPlayer.fadeOutMusic(100, 0.6);

        });
        newSymbols.forEach((reel, index) => {
            if (reel.length > 0) {
                const delay = (TheCageStatics.FILL_UP_DROP_DURATION * 7) * reel.length;
                tl.add(() => {
                    this._anticipationAnimation[index].state.setAnimation(0, "anticipation_loop", true);
                    this._anticipationAnimation[index].visible = true
                }, '<');
                tl.add(() => {
                    this._anticipationAnimation[index].state.setEmptyAnimation(0, 0);
                    this._anticipationAnimation[index].visible = false
                }, `<${delay}`);
            }
        });

        tl.add(() => {
            if (this._blackoutAnimation){
                this._blackoutAnimation.kill();
            }
            this._blackoutAnimation = gsap.to(this._blackout, {duration:0.1, alpha: 0});


            TheCage.soundPlayer.stopSound(TheCageSound.ANTICIPATION_START, 50);
            if (!landedFinalScatter) {
                TheCage.soundPlayer.playSound(TheCageSound.ANTICIPATION_END);
            }
            TheCage.soundPlayer.fadeInMusic(300);
        });

        return tl;
    }

    public startAnticipation() {
        if (this._blackoutAnimation){
            this._blackoutAnimation.kill();
        }
        this._blackoutAnimation = gsap.to(this._blackout, {duration:2, alpha: 0.7});
        //his.waterSpine
        TheCage.soundPlayer.playSound(TheCageSound.ANTICIPATION_START);
        TheCage.soundPlayer.fadeOutMusic(500, 0.7);
    }

    public startAnticipationReel(reel:number) {
        this._anticipationAnimation[reel].state.setAnimation(0, "anticipation_loop", true);
        this._anticipationAnimation[reel].visible = true
    }

    public stopAnticipationReel(reel:number) {
        this._anticipationAnimation[reel].state.setEmptyAnimation(0, 0);
        this._anticipationAnimation[reel].visible = false
    }

    public stopAnticipation() {
        if (this._blackoutAnimation){
            this._blackoutAnimation.kill();
        }
        this._blackoutAnimation = gsap.to(this._blackout, {duration:0.1, alpha: 0});


        TheCage.soundPlayer.stopSound(TheCageSound.ANTICIPATION_START, 50);
        if (TheCage.reelView.avalancheMatrixModel.getAllSymbolsWithName("S1").length != 3) {
            TheCage.soundPlayer.playSound(TheCageSound.ANTICIPATION_END);
        }
        TheCage.soundPlayer.fadeInMusic(300);
    }

    public getBounceShake():gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(gsap.to(this, {duration:0.05, x:-4, y:3}));
        tl.add(gsap.to(this, {duration:0.05, x: 0, y:0}));

        return tl;
    }

    public getExplodeShake():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(()=>{this.position.set(0,0)});
        tl.add(gsap.to(this.position, {
            duration:0.3,
            x:"-=3",
            ease:TheCageStatics.explodeWiggle
        }));
        tl.add(gsap.to(this.position, {
            duration:0.4,
            y:"-=5",
            ease:TheCageStatics.explodeWiggle
        }),0);
        tl.add(()=>{this.position.set(0,0)});

        return tl;
    }

/*    public xBetToggle(state:ToggleState){
        if (state == ToggleState.ON){
            this.turnOnBoost(false);
            //this.xBetGfx.state.setAnimation(0, "switchOn",false);
        } else {
            this.turnOffBoost(false);
            //this.xBetGfx.state.setAnimation(0, "off", false);
        }
    }*/
}